import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/collect-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/blade-loanPost/loanPost/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-loanPost/loanPost/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanPost/loanPost/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanPost/loanPost/submit',
        method: 'post',
        data: row
    })
}


//actionPage
export const actionPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/actionPage',
        url: "/api/v2/blade-loanPost/loan/action-page",
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//negotiationsPage
export const negotiationsPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/negotiationsPage',
        url: '/api/v2/blade-loanPost/loan/negotiations-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//settlePage
export const settlePage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/settlePage',
        url: '/api/blade-DecompressTransfer/DecompressTransfer/decompress-transfer',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//distressedAssetPage
export const distressedAssetPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/distressedAssetPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//violationOfRegulationsPage
export const violationOfRegulationsPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/violationOfRegulationsPage',
        url: '/api/v2/blade-loanPost/loan/violationOfRegulationsPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//proceedingPage
export const proceedingPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/proceedingPage',
        url: '/api/blade-legalManagement/legalManagement/proceedingPageDate',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


///baseInfo
export const baseInfo = (loanPostId, loanInformationId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/baseInfo',
        url: '/api/v2/blade-loanPost/loan/baseInfo',
        method: 'post',
        data: {
            loanPostId,
            loanInformationId
        }
    })
}

//repaymentPlans
export const repaymentPlans = (loanPostId, repaymentType) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/repaymentPlans',
        url: '/api/v2/blade-loanPost/loan/repaymentPlans',
        method: 'post',
        data: {
            loanPostId,
            repaymentType
        }
    })
}


//collectionOperatorLog
export const collectionOperatorLog = (loanPostId) => {
    return request({
        url: '/api/blade-loanPost/loanPost/collectionOperatorLog',
        method: 'post',
        data: {
            loanPostId
        }
    })
}

//collect-enable-select-user-list
export const collectEnableSelectUserList = () => {
    return request({
        url: '/api/blade-loanPost/loanPost/collect-enable-select-user-listNew',
        method: 'get',
    })
}

//dept-collect-enable-select-user-list
export const deptCollectEnableSelectUserList = () => {
    return request({
        url: '/api/blade-loanPost/loanPost-dept/collect-enable-select-user-list',
        method: 'get',
    })
}


///collector-allocation-info
export const collectorAllocationInfo = (userId) => {
    return request({
        url: `/api/blade-loanPost/loanPost/collector-allocation-info?userId=${userId}`,
        method: 'post',
    })
}

///collector-allocation
export const collectorAllocation = (row) => {
    return request({
        url: '/api/blade-loanPost/loanPost/collector-allocation',
        method: 'post',
        data: row
    })
}


//collector-repayment-detail
export const collectorRepaymentDetail = (loanPostId, deptAction) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/collector-repayment-detail?loanPostId=' + loanPostId + '&deptAction=' + deptAction,
        url: `/api/v2/blade-loanPost/loan/collector-repayment-detail?loanPostId=${loanPostId}&deptAction=${deptAction}`,
        method: 'get',
    })
}

//  租后详情-滞纳金明细
export const overdueFeeDetails = (loanPostId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
        url: '/api/v2/blade-loanPost/loan/overdue-fee-details?loanPostId=' + loanPostId,
        method: 'get',
    })
}

// 租后详情-费用记录
export const expenseRecord = (loanPostId) => {
  return request({
      // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
      url: '/api/v2/blade-loanPost/loan/expenseRecord',
      method: 'post',
      data:{
        loanPostId
      }
  })
}

// 租后详情-滞纳金明细
export const overdueFineDetail = (loanPostId) => {
  return request({
      // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
      url: '/api/v2/blade-loanPost/loan/overdueFineDetail',
      method: 'post',
      data:{
        loanPostId
      }
  })
}

// 代理商-管理费明细
export const agentOverdueFineDetail = (loanPostId) => {
  return request({
      // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
      url: '/api/v2/blade-loanPost/loan/agent-overdueFineDetail',
      method: 'post',
      data:{
        loanPostId
      }
  })
}

// 租后详情-查看结清明细
export const settleDetail = (loanPostId) => {
  return request({
      // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
      url: '/api/v2/blade-loanPost/loan/settleDetail',
      method: 'post',
      data:{
        loanPostId
      }
  })
}

// 租后详情-客户营收明细
export const customerRevenue = (loanPostId) => {
  return request({
      // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
      url: '/api/v2/blade-loanPost/loan/customerRevenue',
      method: 'post',
      data:{
        loanPostId
      }
  })
}

//treasurer-repayment-list
export const treasurerRepaymentList = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/treasurer-repayment-list',
        url: '/api/v2/blade-loanPost/loan/treasurer-repayment-list',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//treasurer-repayment-detail
export const treasurerRepaymentDetail = (loanPostId, currentTenancy, type) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/treasurer-repayment-detail?loanPostId=' + loanPostId,
        url: '/api/v2/blade-loanPost/loan/treasurer-repayment-detail?loanPostId=' + loanPostId + "&currentTenancy=" + currentTenancy + "&type=" + type,
        method: 'get',
    })
}

//dept treasurer-repayment-detail
export const deptTreasurerRepaymentDetail = (loanPostId,loanRepaymentPlanId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost-dept/treasurer-repayment-detail?loanPostId=' + loanPostId,
        url: `/api/v2/blade-loanPost/loanPost-dept/treasurer-repayment-detail?loanPostId=${loanPostId}&loanRepaymentPlanId=${loanRepaymentPlanId}`,
        method: 'get',
    })
}

export const newTreasurerRepaymentDetail = (loanPostId,loanRepaymentPlanId) => {
  return request({
      // url: '/api/blade-loanPost/loanPost-dept/treasurer-repayment-detail?loanPostId=' + loanPostId,
      url: `/api/v2/blade-loanPost/loanPost-dept/new-treasurer-repayment-detail?loanPostId=${loanPostId}&loanRepaymentPlanId=${loanRepaymentPlanId}`,
      method: 'get',
  })
}

//treasurer-repayment
export const treasurerRepayment = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/treasurer-repayment',
        url: '/api/v2/blade-loanPost/loan/treasurer-repayment',
        method: 'post',
        data: row
    })
}

export const newTreasurerRepayment = (row) => {
  return request({
      // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/treasurer-repayment',
      url: '/api/v2/blade-loanPost/loan/new-treasurer-repayment',
      method: 'post',
      data: row
  })
}

export const lateFeeTreasurerRepayment = (row) => {
  return request({
      // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/treasurer-repayment',
      url: '/api/v2/blade-loanPost/loan/late-fee-treasurer-repayment',
      method: 'post',
      data: row
  })
}

//collector-repayment-records
export const collectorRepaymentRecords = (loanPostId) => {
    return request({
        url: `/api/blade-loanPost/loanPost/collector-repayment-records?loanPostId=${loanPostId}`,
        method: 'get',
    })
}


export const collectorRepaymentRecordsList = (loanPostId) => {
    return request({
        url: `/api/blade-negotiate/negotiatePayment/paymentHasBeenReceived/${loanPostId}`,
        method: 'get',
    })
}

export const lateFeePaymentHasBeenReceived = (loanPostId) => {
  return request({
      url: `/api/blade-negotiate/negotiatePayment/lateFee-paymentHasBeenReceived/${loanPostId}`,
      method: 'get',
  })
}

export const newPaymentHasBeenReceived = (loanPostId) => {
  return request({
      url: `/api/blade-negotiate/negotiatePayment/newPaymentHasBeenReceived/${loanPostId}`,
      method: 'get',
  })
}

//insurancePage
export const insurancePage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/insurancePage',
        url: '/api/v2/blade-loanPost/loan/insurancePage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//gps-page
export const gpsPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/gps-page',
        url: '/api/v2/blade-loanPost/loan/gps-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}




//getProceedingInfo
export const getProceedingInfo = (repaymentPlanId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/getProceedingInfo?loanPostId=' + loanPostId,
        url: `/api/blade-legalManagement/legalManagement/threeDisposeDetails/${repaymentPlanId}`,
        method: 'get',
    })
}

//getProceedingInfo
export const getProceedingInfoOther = (repaymentPlanId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/getProceedingInfo?loanPostId=' + loanPostId,
        url: `/api/blade-legalManagement/legalManagement/queryLawsuit/${repaymentPlanId}`,
        method: 'get',
    })
}


//operatorLog
export const operatorLog = (loanPostId) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/operatorLog?type=web&loanPostId=' + loanPostId,
        method: 'get',
    })
}


//dept-collect-page
export const deptCollectPage = (current, size, params) => {
    return request({
        // url: '/api/v2/blade-loanPost/loanPost-dept/dept-collect-page',
        url: '/api/v2/blade-loanPost/loan/collect-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//dept-action-page
// export const deptActionPage = (current, size, params) => {
//     return request({
//         url: '/api/blade-loanPost/loanPost-dept/dept-action-page',
//         method: 'post',
//         data: {
//             ...params,
//             current,
//             size,
//         }
//     })
// }

//dept-negotiations-page
export const deptNegotiationsPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost-dept/dept-negotiations-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//action-enable-select-user-list
export const actionEnableSelectUserList = () => {
    return request({
        // url: '/api/blade-loanPost/loanPost/action-enable-select-user-list',
        url: '/api/v2/blade-loanPost/loan/action-enable-select-user-list',
        method: 'get',
    })
}

//dept-action-enable-select-user-list
export const deptActionEnableSelectUserList = () => {
    return request({
        url: '/api/blade-loanPost/loanPost-dept/dept-action-enable-select-user-list',
        // url: '/api/v2/blade-loanPost/loanPost-dept/dept-action-enable-select-user-list',
        method: 'get',
    })
}


//negotiationsDetail
export const negotiationsDetail = (data) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/negotiationsDetail',
        url: '/api/v2/blade-loanPost/loanPost-dept/negotiationsDetail',
        method: 'get',
        params: {
            ...data
        }
    })
}

//代理商违约结清-谈判详情页
export const newAgentNegotiationsDetail = (data) => {
  return request({
      url: '/api/v2/blade-loanPost/loanPost-dept/new-agent-negotiationsDetail',
      method: 'get',
      params: {
          ...data
      }
  })
}

//集团-门店谈判-违约结清明细-谈判详情页
export const newNegotiationsDetail = (data) => {
  return request({
      url: '/api/v2/blade-loanPost/loanPost-dept/new-negotiationsDetail',
      method: 'get',
      params: {
          ...data
      }
  })
}

export const negotiationsPayDetail = (negotiatePaymentId) => {
    return request({
        url: `/api/blade-negotiate/negotiatePayment/repaymentScheduleQuery/${negotiatePaymentId}`,
        method: 'get',
    })
}



//settlementPage
export const settlementPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/settlementPage',
        url: '/api/v2/blade-loanPost/loan/settslementList-list',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//settlementDetail
export const settlementDetail = (id, sId, loanRepaymentPlanId, needReceiveFundType) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/settlementDetail',
        url: '/api/v2/blade-loanPost/loan/settlementDetail',
        method: 'get',
        params: {
            loanPostId: id,
            settlementDataId: sId,
            loanRepaymentPlanId: loanRepaymentPlanId,
            needReceiveFundType: needReceiveFundType
        }
    })
}

export const settleReject = (data) => {
  return request({
      // url: '/api/blade-loanPost/loanPost/settlementDetail'
      url: '/api/v2/blade-loanPost/loan/settleReject',
      method: 'post',
      data
  })
}


//treasurer-repayment-list
export const treasurerRepaymentListRecords = (lId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/treasurer-repayment-list-records',
        // url: '/api/v2/blade-loanPost/loan/treasurer-repayment-list',
        url: '/api/v2/blade-loanPost/loan/operatorLogLoan',
        method: 'get',
        params: {
            loanPostId: lId,
            type:'web'
        }
    })
}



export const collectorRepayment = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/collector-repayment',
        method: 'post',
        data: row
    })
}

export const collectAdd = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/collect-add',
        url: '/api/v2/blade-loanPost/loan/collect-add',
        method: 'post',
        data: row
    })
}

export const collectHandover = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/collect-handover',
        method: 'post',
        data: row
    })
}

export const compensationHandover = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/compensation-handover',
      method: 'post',
      data: row
  })
}


export const customerRepayment = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/customer-repayment',
        method: 'post',
        data: row
    })
}


export const securityDepositDeduction = (row) => {
    return request({
        // url: '/api/v2/blade-loanPost/loan/security-deposit-deduction',
        url: '/api/v2/blade-loanPost/loan/security-deposit-deduction',
        method: 'post',
        data: row
    })
}

export const actionTrailer = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/action-trailer',
        method: 'post',
        data: row
    })
}

export const actionTrailerCar = (row) => {
  return request({
      url: '/api/blade-loanCarManage/loanCarManage/actionTransfer',
      method: 'post',
      data: row
  })
}

export const actionTransfer = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/legal_affairs',
        method: 'post',
        data: row
    })
}

export const actionTransferChat = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/actionTransfer',
        method: 'post',
        data: row
    })
}

export const proceedingTransferNegotiations = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/proceedingTransferNegotiations',
        method: 'post',
        data: row
    })
}

export const compensationPageDate = (current, size, params) => {
    return request({
        url: '/api/blade-compensation/compensationManagement/compensationPageDate',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


export const negotiatePaymentPageDate = (current, size, params) => {
    return request({
        url: '/api/blade-negotiate/negotiatePayment/negotiatePaymentPageDate',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


// 客户违约结清
export const settleOtherSubmit = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/collect-samages-amoun',
        method: 'post',
        data: row
    })
}

// 代理商违约结清
export const agentSettleOtherSubmit = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/agent-collect-samages-amoun',
      method: 'post',
      data: row
  })
}

//滞纳金分期收款
export const lateFeeInstallments = (current, size, params) => {
  return request({
      url: '/api/blade-negotiate/negotiatePayment/late-fee-installments',
      method: 'post',
      data: {
          ...params,
          current,
          size,
      }
  })
}

//谈判收款
export const negotiatePaymentList = (current, size, params) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/negotiate_payment-list',
      method: 'post',
      data: {
          ...params,
          current,
          size,
      }
  })
}

// 应收实收明细表列表
export const getHadReceivedListByLoanInformationId = (id) => {
  return request({
      url: '/api/blade-loanRepaymentPlanDetailed/loanRepaymentPlanDetailed/getHadReceivedListByLoanInformationId',
      method: 'get',
      params: {
        loanInformationId: id
      }
  })
}


// 还款计划表列表
export const getPlanListByLoanInformationId = (id) => {
  return request({
      url: '/api/blade-loanRepaymentPlanDetailed/loanRepaymentPlanDetailed/getPlanListByLoanInformationId',
      method: 'get',
      params: {
        loanInformationId: id
      }
  })
}

//通用租后详情-基础信息全
export const baseInfoAll = (loanPostId) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/baseInfoAll',
      method: 'post',
      data: {
        loanPostId
      }
  })
}


/**
 * 投诉结清详情
 */
export const complaintSettleDetail = (loanPostId) => {
  return request({
      url: '/api/v2/blade-loanPost/loanPost-dept/complaintSettlementDetails',
      method: 'get',
      params: {
        loanPostId
      }
  })
}

// 客户列表-投诉处理-投诉结清
export const complaintSettleSubmit = (data) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/complaint-collect-samages-amoun',
        method: 'post',
        data: {
            ...data
        }
    })
}

/**
 * 转投诉
 */
export const transferComplaint = (data) => {
    console.log(data);
    return request({
        url: '/api/v2/blade-loanPost/loan/transferComplaint',
        method: 'post',
        data: data
    })
}

/**
 * 投诉结清-转法务
 */
export const complainSettleLegalAffairs = (data) => {
    console.log(data);
    return request({
        url: '/api/v2/blade-loanPost/loan/complain_settlement_legal_affairs',
        method: 'post',
        data: data
    })
}